import { supabase } from '../lib/supabase'
import { setCached } from '../lib/queryCache'
import { useResilientList } from './useResilientList'

const USERS_CACHE_KEY = 'users:team'

// List all team members (employees) from user_profiles. Used by the Tasks
// page assignee filter and anywhere else we need to enumerate the team.
//
// Built on useResilientList so a hung user_profiles query can no longer pin
// every assignee picker on a spinner: cache-first paint + bounded loading +
// stale-skeleton watchdog. (user_profiles isn't synced to PGlite yet, so the
// offline fallback is a no-op until it's added to SYNC_TABLES — the cache and
// timeout still apply.)
export function useUsers() {
  const { items, loading, error, refetch } = useResilientList({
    cacheKey: USERS_CACHE_KEY,
    queryFn: () => supabase
      .from('user_profiles')
      .select('id, full_name, email')
      .order('full_name', { ascending: true, nullsFirst: false }),
    table: 'user_profiles',
  })
  return { users: items, loading, error, refetch }
}

// Clear the cache (e.g. after a user profile edit) so the next mount refetches.
export function invalidateUsersCache() {
  setCached(USERS_CACHE_KEY, null)
}
